<template>
  <div :class="[`grid grid-cols-${nbCols} bg-green-500 bg-opacity-50`]">
    <slot />
  </div>
</template>

<script>
let classes = ['grid-cols-1 grid-cols-2 grid-cols-3 grid-cols-4 grid-cols-5 grid-cols-6'];
export default {
  props: {
    content: String,
    nbCols : {
      type : Number,
      default : 2
    }
  },
};
</script>